module.exports = __webpack_public_path__ + "img/2c1b0e4c20fb64877cd58a61ed7d1cc6.b1b1cd7e.png";